<script lang="ts">

    export let size = 15;
    export let color = '#000000';
    export let right = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size * 1.7492} class:invert={right} viewBox="0 0 13.503 23.619">
    <path fill={color} d="M15.321,18l8.937-8.93a1.688,1.688,0,0,0-2.391-2.384L11.742,16.8a1.685,1.685,0,0,0-.049,2.327L21.86,29.32a1.688,1.688,0,0,0,2.391-2.384Z" transform="translate(-11.251 -6.194)"/>
  </svg>
  

<style lang="scss">

    .invert {
        transform: scaleX(-1);
    }

</style>
